import { Link } from 'react-router-dom';

/**
 * Crawlable prose section. The rest of the home page is short marketing copy split across
 * cards, which gives search engines almost no running text to judge the page by. This block
 * states, in plain sentences, what Hooshpaz is and which cooking problems it solves — including
 * the brand written the way people actually type it (هوش پز / هوشپز), because search engines
 * treat those spellings as different strings from the ZWNJ form used in the design.
 */
const useCases = [
    'وقتی یخچال پر است اما نمی‌دانی امشب چی بپزی',
    'وقتی فقط چند ماده ساده داری و دنبال یک دستور پخت سریع می‌گردی',
    'وقتی رژیم داری و باید کالری یا کربوهیدرات دستور کم شود',
    'وقتی به یک ماده حساسیت داری و دنبال جایگزین مطمئن هستی',
    'وقتی طرز تهیه یک غذای مشخص را می‌خواهی، با مقدار دقیق مواد',
    'وقتی می‌خواهی از مواد باقی‌مانده غذا بسازی و دورریز را کم کنی',
];

const WhyHooshpaz = () => (
    <section id="about-hooshpaz" className="section why-section">
        <div className="site-container why-layout">
            <div className="section-heading align-start compact">
                <span>هوش‌پز چیست؟</span>
                <h2>دستیار آشپزی هوشمند فارسی برای ساخت دستور پخت</h2>
            </div>

            <div className="why-prose">
                <p>
                    <strong>هوش‌پز</strong> (که خیلی‌ها آن را «هوش پز» یا «هوشپز» می‌نویسند) یک
                    اپلیکیشن فارسی برای اندروید، با نسخه وب برای آیفون و مرورگر، است که با کمک <strong>هوش مصنوعی آشپزی</strong>، از
                    مواد اولیه‌ای که همین حالا در آشپزخانه داری یک <strong>دستور پخت</strong> کامل
                    می‌سازد: مقدار مواد، مراحل مرتب، زمان آماده‌سازی و پخت، تعداد نفرات، سطح سختی و
                    کالری تقریبی هر وعده.
                </p>
                <p>
                    برخلاف جست‌وجوی معمولِ طرز تهیه، مسیر در هوش‌پز برعکس است: به‌جای اینکه اول اسم
                    غذا را انتخاب کنی و بعد دنبال مواد بگردی، از چیزی شروع می‌کنی که داری. مواد را
                    تایپ می‌کنی یا از آن‌ها عکس می‌گیری، و این <strong>دستیار آشپزی هوشمند</strong>
                    {' '}فهرست تشخیص‌داده‌شده را نشان می‌دهد تا قبل از ساخت غذا اصلاحش کنی. اگر هم
                    فقط اسم یک غذا را بنویسی، همان را با مواد و مراحل کاملش تحویل می‌گیری.
                </p>
                <p>
                    هر دستور پخت پایان کار نیست. با ویرایش هوشمند می‌توانی کالری یا کربوهیدرات همان
                    دستور را کم کنی، چند ماده را با گزینه‌ای دیگر عوض کنی یا تغییر دلخواهت را با
                    زبان خودت بنویسی تا نسخه تازه‌ای از همان غذا ساخته شود. دستورهای ساخته‌شده در
                    تاریخچه و علاقه‌مندی‌های حساب تو می‌مانند و می‌توانی آن‌ها را با یک لینک برای
                    دیگران بفرستی.
                </p>
                <p className="why-links">
                    مجموعه <Link className="inline-link" to="/recipes">دستور پخت‌های منتخب هوش‌پز</Link>{' '}
                    را ببین، <Link className="inline-link" to="/about">درباره هوش‌پز</Link> بخوان یا
                    پاسخ پرسش‌هایت را در{' '}
                    <Link className="inline-link" to="/faq">سوالات متداول</Link> پیدا کن.
                </p>
            </div>

            <div className="why-usecases">
                <h3>هوش‌پز به چه کاری می‌آید؟</h3>
                <ul>
                    {useCases.map((item) => <li key={item}>{item}</li>)}
                </ul>
            </div>
        </div>
    </section>
);

export default WhyHooshpaz;
